module.exports = __webpack_public_path__ + "static/media/Solveproblems_icon.aec615d2.svg";